import { Link } from "react-router-dom";
import { entityTrack } from "@/lib/entities";
import { fmtPct, pctColor } from "./nl";

/* Associated Token Band — Figma contract. Protocol (Aave) and token (AAVE)
   remain separate canonical identities. Hidden entirely when no token exists. */

export const AssociatedToken = ({ overview }: { overview: any }) => {
  const tok = overview.token;
  if (!tok?.symbol) return null;
  const name = overview.identity.name;
  const price = tok.price_usd != null
    ? `$${tok.price_usd < 10 ? tok.price_usd.toFixed(3) : tok.price_usd.toFixed(2)}` : "—";
  return (
    <div className="rounded-[20px] lg:rounded-[22px] bg-[#06060a] border border-[#222234] px-[18px] py-[18px] md:px-[24px] md:py-[22px] lg:px-[28px] lg:py-[26px]"
      data-testid="associated-token-band">
      <p className="nl-geist text-[8px] md:text-[10px] leading-[12px] md:leading-[14px] font-semibold tracking-[0.08em] md:tracking-[0.9px] text-[#8b5cff] uppercase">
        ASSOCIATED TOKEN&nbsp;&nbsp;·&nbsp;&nbsp;DISTINCT ENTITY
      </p>
      <div className="mt-[12px] md:mt-[10px] flex flex-col md:flex-row md:items-center gap-[10px] md:gap-[32px]">
        <div className="flex items-start justify-between md:block md:flex-1 min-w-0">
          <div className="min-w-0">
            <p className="nl-sg text-[32px] leading-[38px] md:text-[30px] md:leading-[35px] lg:text-[44px] lg:leading-[48px] font-bold tracking-[-0.01em] text-white"
              data-testid="token-symbol">{tok.symbol}</p>
            <p className="nl-geist hidden lg:block text-[14px] leading-[22px] text-[#b9b9c7] mt-[10px] max-w-[520px]">
              The {name} protocol and {tok.symbol} token remain separate canonical identities across Search, Entity Intelligence and coverage.
            </p>
          </div>
          <div className="md:hidden text-right shrink-0 pl-[16px]">
            <p className="nl-sg text-[27px] leading-[32px] font-medium tracking-[-0.01em] text-white">{price}</p>
            {tok.change_24h_pct != null && (
              <p className="nl-mono text-[9px] leading-[13px] font-medium mt-[2px]" style={{ color: pctColor(tok.change_24h_pct, true) }}>
                {fmtPct(tok.change_24h_pct)} 24H
              </p>
            )}
          </div>
        </div>
        <p className="nl-geist md:hidden text-[12px] leading-[18px] text-[#b9b9c7] max-w-[290px]">
          Protocol and token remain separate canonical NewsLayer identities.
        </p>
        <div className="hidden md:block shrink-0">
          <p className="nl-sg text-[28px] leading-[34px] lg:text-[34px] lg:leading-[38px] font-medium tracking-[-0.01em] text-white"
            data-testid="token-price">{price}</p>
          {tok.change_24h_pct != null && (
            <p className="nl-mono text-[10px] lg:text-[12px] leading-[15px] lg:leading-[18px] font-medium mt-[4px]"
              style={{ color: pctColor(tok.change_24h_pct, true) }} data-testid="token-24h">
              {fmtPct(tok.change_24h_pct)}&nbsp;&nbsp;24H
            </p>
          )}
        </div>
        <Link to={tok.route || "#"} className="shrink-0 mt-[8px] md:mt-0 nl-geist text-[9px] md:text-[10px] lg:text-[11px] leading-[13px] lg:leading-[16px] font-semibold tracking-[0.06em] text-[#8b5cff] hover:text-white transition-colors duration-200"
          onClick={() => entityTrack("token_click", overview.identity.entity_id, { from: "token_band" })}
          data-testid="token-view-cta">
          <span className="md:hidden">VIEW {tok.symbol} TOKEN&nbsp;&nbsp;→</span>
          <span className="hidden md:inline lg:hidden">VIEW TOKEN&nbsp;&nbsp;→</span>
          <span className="hidden lg:inline">VIEW {tok.symbol} TOKEN&nbsp;&nbsp;→</span>
        </Link>
      </div>
    </div>
  );
};
